import { useOutletContext } from 'react-router-dom'

import EarningsSection from './EarningsSection/EarningsSection'
import * as Styles from './styles'

const GlobalTab = () => {
  const { periodParams } = useOutletContext()

  return (
    <Styles.Container>
      <EarningsSection periodParams={periodParams} />
    </Styles.Container>
  )
}

export default GlobalTab
